module.exports = __webpack_public_path__ + "img/website-icon.b35dde3d.svg";